import React, { Component } from "react";
import { Button } from "reactstrap";
import { Dialog } from "@mui/material";
import { DialogTitle } from "@mui/material";
import { DialogContent } from "@mui/material";
import { DialogActions } from "@mui/material";
import { DialogContentText } from "@mui/material";

export interface Props {
  open: boolean;
  title: string;
  contentText: string;
  okButtonTitle: string;
  cancelButtonTitle: string;
  handleClose: (success: boolean) => void;
}

export class AlertDialog extends Component<Props, {}> {
  render() {
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={() => this.props.handleClose(false)}
        >
          <DialogTitle>{this.props.title ?? "Confirm action"}</DialogTitle>
          <DialogContent>
            <DialogContentText>{this.props.contentText}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.props.handleClose(true)}
              color="primary"
              autoFocus
            >
              {this.props.okButtonTitle ?? "Agree"}
            </Button>
            <Button
              onClick={() => this.props.handleClose(false)}
              color="secondary"
            >
              {this.props.cancelButtonTitle ?? "Cancel"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
